<template>
  <div class="p-relative">
    <c-loading v-if="balanceState.fetching" />
    <div>
      <amount-step
        v-if="step === 1"
        :vaultInfo="vaultInfo"
        :selectedAsset="selectedAsset"
        :balances="balanceState.result"
        :txPayload="txPayload"
        :isAssetReadonly="true"
        @next="setAmount"
        @selectAsset="setAsset"
      />
      <gas-option-step
        v-if="step === 2"
        :vaultInfo="vaultInfo"
        :selectedAsset="selectedAsset"
        :needApproveAccess="needApproveAccess"
        :txPayload="txPayload"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import AmountStep from "../deposit/AmountStep.vue";
import GasOptionStep from "../deposit/GasOptionStep.vue";

export default {
  components: {
    AmountStep,
    GasOptionStep,
  },
  data: () => ({
    step: 1,
    selectedAsset: null,
    txPayload: {
      amount: 0,
    },
  }),
  computed: {
    ...mapGetters({
      getVaultByTypeAndToken: "projectConfig/getVaultByTypeAndToken",
      getVaultByIdentity: "projectConfig/getVaultByIdentity",
      projects: "projectConfig/projects",
      walletSelected: "userWallets/walletSelected",
      balanceState: "vaults/coinBalances",
      tokenAllowanceState: "vaults/tokenAllowance",
    }),
    vaultInfo() {
      const currentVaultInfo = this.getVaultByIdentity(
        this.$route.params.vault
      );
      const migratingVaultInfo = this.getVaultByTypeAndToken({
        type: currentVaultInfo.migrateTo,
        token: currentVaultInfo.coin,
      });
      return {
        type: currentVaultInfo.migrateTo,
        token: currentVaultInfo.coin,
        ...migratingVaultInfo,
      };
    },
    loadingData() {
      return this.balanceState.fetching || this.tokenAllowanceState.fetching;
    },
    needApproveAccess() {
      return (
        this.selectedAsset?.approveAccessRequired &&
        !this.tokenAllowanceState.fetching &&
        new BN(this.tokenAllowanceState.result?.amount || 0).isEqualTo(0)
      );
    },
  },
  methods: {
    async getTokenAllowance() {
      if (!this.selectedAsset?.approveAccessRequired) return;
      await this.$store.dispatch("vaults/fetchTokenAllowance", {
        vault: this.selectedAsset?.type || this.vaultInfo.type,
        token: this.selectedAsset.coin,
        zap: this.selectedAsset.isZap ? "in" : undefined,
      });
    },
    setProject() {
      this.$store.dispatch(
        "projectConfig/setCurrentProject",
        this.projects.find(p => p.name === "ethereum")
      );
    },
    setAsset(asset) {
      this.selectedAsset = asset || this.vaultInfo;
      if (this.walletSelected?.coin_network === "ethereum") {
        this.getTokenAllowance();
      }
    },
    setAmount(amount) {
      this.txPayload.amount = amount;
      this.step = 2;
    },
  },
  mounted() {
    this.setProject();
    this.setAsset();
  },
  watch: {
    walletSelected: {
      immediate: true,
      handler({ address, coin_network }) {
        if (address && coin_network === "ethereum") {
          this.getTokenAllowance();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.deposit-box {
  width: 630px;
  height: 690px;
  border: 1px solid #49d999;
  border-radius: 16px;
}
</style>
